import { render, staticRenderFns } from "./rubric.vue?vue&type=template&id=24be2575&lang=html&"
import script from "./rubric.vue?vue&type=script&lang=ts&"
export * from "./rubric.vue?vue&type=script&lang=ts&"
import style0 from "./rubric.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports